module.exports = __webpack_public_path__ + "static/media/PDF_79.dbd4574f.pdf";